import { useAnonymous } from "@web/app/hooks";
import { useIsMapEnabled } from "@web/app/map/map.config";
import Paths from "@web/common/Paths";
import { Navigate, useLocation } from "react-router-dom";

import Config from "../config/Config";

/**
 * Redirect to the user's default app section, preserving the query string.
 * Used for /app, unmatched /app/* paths, and any unmatched path for an
 * authenticated user.
 */
export function DefaultAppRedirect() {
	const anonymousUser = useAnonymous();
	const isMapEnabled = useIsMapEnabled();
	const location = useLocation();

	const pathname = anonymousUser
		? Paths.Tracking
		: Config.somewear.messages.enable
			? Paths.Conversations
			: isMapEnabled
				? Paths.Tracking
				: Paths.Settings;

	return <Navigate to={{ pathname, search: location.search }} replace />;
}
